/**
 * The name the file of a letter of authority has on the server: `letterOfAuthority` and the extension of the file (`letterOfAuthority.pdf`). The cash desk finds the file by it, and the old editor
 * named the file so too — it is a key, not a name for a person.
 */
const SERVER_NAME = /^letterOfAuthority(\.[A-Za-z0-9]{1,5})?$/i;

/**
 * How a file of a letter of authority is called on a screen: the server's own name reads «Доверенность» with the extension (`Доверенность.pdf`), any other name — the one an operator gave a file that
 * was put before the server named it so — is shown as it is.
 */
export function authorityFileLabel(fileName: string, word: string): string {
  const name = fileName.trim();
  const match = SERVER_NAME.exec(name);
  return match ? `${word}${(match[1] ?? '').toLowerCase()}` : name;
}
